module.exports = __webpack_public_path__ + "static/media/pe.c0c4a4ce.webp";